import './App.css';
import React, { useState, useEffect } from 'react';
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from 'react-query';

import ThemeContainer from './Theme';
import store from './Redux/store';
import ScrollProgress from './Views/Components/LockerMenu/component/ScrollProgress';
import Loader from './Views/Components/LockerMenu/component/Loader';

// Create a new QueryClient instance
const queryClient = new QueryClient();

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handlePageLoad = () => {
      setLoading(false);
    };

    if (document.readyState === 'complete') {
      handlePageLoad();
    } else {
      window.addEventListener('load', handlePageLoad);
    }

    return () => window.removeEventListener('load', handlePageLoad);
  }, []);

  return (
    <Provider store={store}>
      {/* Wrap everything in QueryClientProvider */}
      <QueryClientProvider client={queryClient}>
        {loading ? (
          <Loader />  
        ) : (
          <>
            <ScrollProgress />
            <ThemeContainer />
          </>
        )}
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
